export default "__VITE_ASSET__DKZh1WVO__"